import {Injectable} from '@angular/core';
import {AES, enc, SHA256} from 'crypto-js';

@Injectable()
export class TokenService {

  private getEncryptionKey(): string {
    let key: string = sessionStorage.getItem("app_id_context");
    if (!key) {
      const randomSeed: string = Math.random().toString(36).substring(2) + Date.now().toString(36);
      key = SHA256(randomSeed).toString();
      sessionStorage.setItem("app_id_context", key);
    }

    return key;
  }

  secureSave(storageKey: string, data: any): void {
    if (!data) return;
    try {
      const key: string = this.getEncryptionKey();
      const jsonData: string = JSON.stringify(data);
      const encrypted = AES.encrypt(jsonData, key).toString();
      localStorage.setItem(storageKey, encrypted);
    } catch (e) {
      console.error("Encryption failed", e);
    }
  }

  secureGet(storageKey: string) {
    const encrypted: string = localStorage.getItem(storageKey);
    if (!encrypted) return null;

    const key: string = this.getEncryptionKey();

    try {
      const bytes = AES.decrypt(encrypted, key);
      const decryptedString = bytes.toString(enc.Utf8);

      if (!decryptedString) return null;
      return JSON.parse(decryptedString);
    } catch (e) {
      console.error("Decryption or Parse failed, clearing key", e);
      localStorage.removeItem(storageKey);
      return null;
    }
  }
}
